var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_133_915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.99219 18C1.99219 18.5625 2.1875 19.0391 2.57812 19.4297C2.96875 19.8203 3.44531 20.0156 4.00781 20.0156H13.9922C14.5547 20.0156 15.0312 19.8203 15.4219 19.4297C15.8125 19.0391 16.0078 18.5625 16.0078 18V6H18V4.00781H13.9922V2.01562C13.9922 1.45312 13.7969 0.976565 13.4062 0.585938C13.0156 0.195311 12.5469 0 12 0H6C5.45312 0 4.98438 0.195311 4.59375 0.585938C4.20312 0.976565 4.00781 1.45312 4.00781 2.01562V4.00781H0V6H1.99219V18ZM6 2.01562H12V4.00781H6V2.01562ZM4.99219 6H13.9922V18H4.00781V6H4.99219ZM6 8.01562H7.99219V16.0078H6V8.01562ZM10.0078 8.01562H12V16.0078H10.0078V8.01562Z",
    fill: "#7D7566"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_133_915"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 20.0156,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelIcon);
export default __webpack_public_path__ + "static/media/del-icon.f600473bbb0f4e349f7d448e91eb6891.svg";
export { ForwardRef as ReactComponent };